import React from "react"
import { getUserByCognitoId } from "../../../../../functions/FilterUsers"
import { useAppSelector } from "../../../../../stores/hooks"
import { RootState } from "../../../../../stores/store"
import { getCircleColor, getRectColor } from "../utils/PostitUtils"
import AutoFitSvgText from "./AutoFitSvgText"
import Avatar from "../components/Avatar"

interface IProps {
  card?: ICard
  currentCardText?: string
}

const CardLayout = ({ card, currentCardText }: IProps): React.JSX.Element | null => {
  const canvasStore = useAppSelector((state: RootState) => state.canvas)
  const user = getUserByCognitoId(card?.owner ?? "", canvasStore.feedback?.users ?? [])
  const showUser = String(canvasStore.feedback?.identify_user_on_card) !== "false"

  if (!card) return null

  const renderShape = (card: ICard, user?: IUser): React.JSX.Element => {
    if (card.shape === "circle") {
      return (
        <>
          <circle
            id={`card-${card.id}`}
            cx="50"
            cy="105"
            r="30"
            fill={getCircleColor(card, canvasStore.feedback?.users)}
            stroke="silver"
            strokeWidth="0.5"
          />
          {showUser && user && (
            <Avatar
              user={user}
              x={35}
              y={90}
              width={31}
              height={31}
              clipPath="circle(15px at 15px 15px)"
            />
          )}
        </>
      )
    } else {
      return (
        <>
          {showUser && user && (
            <Avatar
              user={user}
              x={101}
              y={0}
              width={15}
              height={15}
              clipPath="circle(7.5px at 7.5px 7.5px)"
            />
          )}
          <rect id={`card-${card.id}`} width="100" height="100" fill={getRectColor(card)} stroke="silver" strokeWidth="0.5" />
        </>
      )
    }
  }

  return (
    <>
      <rect id={`hitbox-${card.id}`} width="100" height="100" fill="transparent" pointerEvents="none" />
      {renderShape(card, user)}
      {card.shape === "square" && <AutoFitSvgText text={currentCardText ?? ""} />}
    </>
  )
}
export default CardLayout
